export const DEVICE_ID_STORAGE_KEY = 'guru-device-id'
